export const isLocalEnv = () =>
  process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost';
